﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class SettingClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    getSettingsFilesByOrganization(organizationAppId) {
        if (organizationAppId) {
            return this.client.apiSettingsOrganizationByIdGet(organizationAppId);
        }
        else {
            return this.client.apiSettingsGlobalGet();
        }
    }
    getAllSettingFiles() {
        return this.client.apiSettingsGet();
    }
    getSettingItem(namespace, organizationAppId, key) {
        if (organizationAppId) {
            return this.client.apiSettingsFileByFileNameOrganizationByIdKeyByKeyGet(namespace, organizationAppId, key);
        }
        else {
            return this.client.apiSettingsFileByFileNameGlobalKeyByKeyGet(namespace, key);
        }
    }
    getSettingFileByNamespaceAndOrganization(namespace, organizationAppId) {
        if (organizationAppId) {
            return this.client.apiSettingsFileByFileNameOrganizationByIdGet(namespace, organizationAppId);
        }
        else {
            return this.client.apiSettingsFileByFileNameGlobalGet(namespace);
        }
    }
    updateSettings(settings) {
        return this.client.apiSettingsPut(settings);
    }
    deleteSettings(settings) {
        return this.client.apiSettingsDelete(settings);
    }
    getCustomerSettings() {
        return this.client.apiSettingsCustomerGet();
    }
    updateCustomerSettings(settings) {
        return this.client.apiSettingsCustomerPut(settings);
    }
}
exports.SettingClient = SettingClient;
//# sourceMappingURL=SettingClient.js.map